const KEY1 = 'get:select_plans';

import {
  GET_GROUP_SELECTED_PLANS
} from '../api/config'
import * as $http from '../api/fetch'

export const state = () => {
    return {
      selected_plans: [],
    };
};

export const mutations = {
    [KEY1](state, val) {
      state.selected_plans = val;
    },
};

export const actions = {
    async [KEY1]({ commit }) {
      if ($http.is_run(GET_GROUP_SELECTED_PLANS)) {
        return false;
      }
      let data = await $http.$axios(GET_GROUP_SELECTED_PLANS);
      if (data.ec == 200) {
        commit(KEY1, data.data.selected_plans);
      }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};